import React from 'react';
import { createRoot } from 'react-dom/client';
import LearnApp from './LearnApp';
import PatternBoard from '../pattern-board-app/PatternBoard';
import { initNavDrawer, initReading, initThemeToggle } from './reading';
import { initSearch } from './search';

// Separate webpack entry → js/dist/learn-app.js, loaded on the /learn pages. The pages are fully
// server-rendered; this adds the contents drawer, search, the theme toggle, the live boards, and
// on article pages the marks, notes, tutor, quiz, comments, reading progress and outline.
initNavDrawer();
initSearch();
initThemeToggle();

// Diagrams: the server renders a static, crawlable board for every ```board block; replace each
// with the same chessground board and controls the /patterns pages use (flip, drag to try a move,
// engine on demand). The caption stays where it is, under the figure.
document.querySelectorAll<HTMLElement>('.lb-figure .lb-board[data-fen]').forEach((el) => {
  const fen = el.dataset.fen;
  if (!fen) return;
  const mount = document.createElement('div');
  mount.className = 'lb-cg';
  el.replaceWith(mount);
  createRoot(mount).render(<PatternBoard line={[]} startFen={fen} />);
});

const article = document.getElementById('learn-article');
const toolbar = document.getElementById('learn-toolbar');
const tutor = document.getElementById('learn-tutor');

if (article && toolbar && tutor) {
  initReading(article);
  const host = document.createElement('div');
  host.className = 'lb-app-host';
  document.body.appendChild(host);
  createRoot(host).render(
    <LearnApp
      article={article}
      title={tutor.dataset.title || ''}
      mounts={{
        toolbar,
        tutor,
        quiz: document.getElementById('learn-quiz-mount'),
        comments: document.getElementById('learn-comments-mount'),
      }}
    />
  );
}
